import bankBTGPactualChile from '../../banksPNG/bankBTGPactualChile.png';

interface IconProps {
	width?: string;
	height?: string;
	alt?: string;
}

export const BancoBtgIcon = ({ width = '17', height = '17', alt = 'Banco BTG' }: IconProps) => (
	<img src={bankBTGPactualChile} width={width} height={height} alt={alt} />
);
